import {motion} from "framer-motion"
import React from "react"

import styles from "./HomeHeroAnimated.module.scss"
import LogoSvg from "./LogoSvg"

interface LogoSvgPositionedProps {
	slideIndex: number
}

const positionMap = [
	{top: "60%", left: "50%", rotate: -27.66},
	{top: "45%", left: "47%", rotate: 0},
	{top: "4%", left: "67%", rotate: -0.41},
]

const LogoSvgPositioned: React.FC<LogoSvgPositionedProps> = ({slideIndex}) => {
	const target = positionMap[slideIndex % positionMap.length]

	return (
		<motion.div
			animate={{
				top: target.top,
				left: target.left,
				rotate: target.rotate,
			}}
			initial={{
				top: positionMap[0].top,
				left: positionMap[0].left,
				rotate: positionMap[0].rotate,
			}}
			transition={{duration: 0.4, ease: "easeInOut"}}
			className={styles.logoSvgPositioned}
			style={{
				position: "absolute",
				width: "30%",
				height: "56%",
				zIndex: 1,
				pointerEvents: "none",
			}}
		>
			<LogoSvg style={{width: "100%", height: "100%"}} />
		</motion.div>
	)
}

export default LogoSvgPositioned
